import React from "react"
import { Button, Card, CardHeader, Table } from "reactstrap"

const TennisGamesTable = ({
	setsDone,
	onButtonClick,
	toggleIsTieBreak,
	isTieBreak,
}) => {
	const homeTeam = JSON.parse(localStorage.getItem("homeTeam") ?? "{}")
	const awayTeam = JSON.parse(localStorage.getItem("awayTeam") ?? "{}")
	const sets = 6
	const columns = []
	const calculation = { homeTeam: 0, awayTeam: 0 }
	for (let i = 0; i < setsDone.homeTeam.length; i++) {
		if (setsDone.homeTeam[i] > setsDone.awayTeam[i]) {
			calculation.homeTeam += 1
		} else {
			calculation.awayTeam += 1
		}
	}

	if (setsDone.homeTeam.length < 8) {
		for (let x = 1; x <= setsDone.homeTeam.length; x++) {
			columns.push(<th key={`setHeader-${x}-game`}>{x}. Game</th>)
		}
		for (let x = setsDone.homeTeam.length + 1; x <= sets; x++) {
			columns.push(<th key={`setHeader-${x}-game`}></th>)
		}
	} else {
		for (let x = 1; x <= setsDone.homeTeam.length; x++) {
			columns.push(<th key={`setHeader-${x}-game`}>{x}.</th>)
		}
	}

	const createRow = (player, key) => {
		const columns = []
		for (let x = 0; x < setsDone.homeTeam.length; x++) {
			const score = setsDone[key][x]
			columns.push(
				<td key={`set-${player.name}-game-${x}`}>
					{score === 50 ? "Adv" : score}
				</td>
			)
		}

		for (let x = setsDone.homeTeam.length; x < sets; x++) {
			columns.push(<td key={`set-${player.name}-game-${x}`}></td>)
		}

		return (
			<tr>
				<td>
					{player.name} {player.surname ?? ""}
				</td>
				<td>
					<b>{calculation[key]}</b>
				</td>
				{columns}
			</tr>
		)
	}

	return (
		<Card>
			<CardHeader>
				<h1 style={{ marginBottom: -4 }}>Game-ovi</h1>
				<div>
					<Button.Ripple
						style={{ marginRight: 32 }}
						color={
							calculation.homeTeam == calculation.awayTeam &&
							!isTieBreak
								? "primary"
								: "secondary"
						}
						onClick={toggleIsTieBreak}
						outline={
							calculation.homeTeam != calculation.awayTeam ||
							calculation.homeTeam < 6 ||
							calculation.awayTeam < 6
						}
					>
						{isTieBreak ? "Odustani od" : "Započni"} Tie-Break
					</Button.Ripple>

					<Button.Ripple
						color={
							calculation.homeTeam == calculation.awayTeam
								? "secondary"
								: "primary"
						}
						onClick={onButtonClick}
						outline={
							calculation.homeTeam == calculation.awayTeam ||
							setsDone.homeTeam.length < sets / 2 ||
							(calculation.homeTeam < 6 && calculation.awayTeam < 6)
						}
						disabled={calculation.homeTeam == calculation.awayTeam}
					>
						Završi set
					</Button.Ripple>
				</div>
			</CardHeader>
			<Table responsive>
				<thead>
					<tr>
						<th>Ime</th>
						<th>Ukupno</th>
						{columns}
					</tr>
				</thead>
				<tbody>
					{createRow(homeTeam, "homeTeam")}
					{createRow(awayTeam, "awayTeam")}
				</tbody>
			</Table>
		</Card>
	)
}

export default TennisGamesTable
